import { format, parseISO } from 'date-fns';
import type { ProjectNote } from '@/api/client';
import type { ProjectNoteDraftItem } from './ProjectNotesPopover.types';

/** Свежие заметки выше: по display_order (новые с большим порядком), затем по дате создания. */
export function sortProjectNotesNewestFirst<
  T extends { note_id: string; display_order: number; created_at: string },
>(notes: T[]): T[] {
  return [...notes].sort((a, b) => {
    if (b.display_order !== a.display_order) return b.display_order - a.display_order;
    const ta = new Date(a.created_at).getTime();
    const tb = new Date(b.created_at).getTime();
    if (tb !== ta) return tb - ta;
    return b.note_id.localeCompare(a.note_id);
  });
}

export function formatNoteDate(iso: string): string {
  try {
    const d = parseISO(iso);
    return format(d, 'dd.MM.yyyy HH:mm');
  } catch {
    return iso;
  }
}

export function draftItemToProjectNote(item: ProjectNoteDraftItem, index: number): ProjectNote {
  return {
    note_id: item.id,
    project_id: '',
    note_content: item.content,
    created_at: new Date().toISOString(),
    created_by: null,
    display_order: index,
  };
}
